import { DialogTrigger } from 'react-aria-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';
import Money from '~/components/Money';
import Button from '~/components/ui/Button';
import { InnerCard } from '~/components/ui/Card';
import { SkeletonCard } from '~/components/ui/Skeleton';
import useActiveSubscription from '~/modules/subscription/useActiveSubscription';
import useBalance from '~/modules/subscription/useBalance';
import TopUpDialog from './TopUpDialog';
import WarningInfo from './WarningInfo';

function BalanceBlock() {
  const { t } = useTranslation('', { keyPrefix: 'subscription.balance' });
  const { data, isLoading, error } = useBalance();
  const { data: activePlan, isLoading: isActivePlanLoading } = useActiveSubscription();

  if (isLoading || error || isActivePlanLoading) {
    return null;
  }

  const balance = data || 0;

  return (
    <>
      {isLoading || isActivePlanLoading ? (
        <SkeletonCard height={167} />
      ) : (
        <InnerCard title={t('title')}>
          <div className="flex justify-between items-center">
            <Money className="font-bold" value={balance} />
            <DialogTrigger>
              <Button variant="outlined" size="sm">
                {t('topUp')}
              </Button>
              <TopUpDialog />
            </DialogTrigger>
          </div>
          {activePlan?.is_renewable && activePlan.plan_price > balance && (
            <WarningInfo iconName="emergency" text={t('warning')} />
          )}
          <div className="border-b border-card-border" />
          <Link
            to="/subscription/transactions"
            className="text-sm font-semibold text-link cursor-pointer w-max"
          >
            {t('transactionsHistory')}
          </Link>
        </InnerCard>
      )}
    </>
  );
}

export default BalanceBlock;
